import ResourceService from "./resource.service";

class ApplicationsService extends ResourceService {
  static get resource() {
    return "applications";
  }
}

export default ApplicationsService;
